// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

const api = new APICore();

type Query = {
    currentPage: number,
    pageSize: number,
    search: string,
};

function getAllSyncJobs(query: Query): any {
    console.log(query);
    
    const page = query.currentPage || PAGINATION_DEFAULT_VALUE.currentPage;
    const page_size = query.pageSize || PAGINATION_DEFAULT_VALUE.pageSize;

    let baseUrl = config.SYNC_JOBS_URL + '/admin';


    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    const queryParam = {
        page: page.toString(),
        page_size: page_size.toString(),
    };

    return api.get(`${baseUrl}`, typeof query === 'object' ? queryParam : undefined, {});
}

export {
    getAllSyncJobs,
};
